import React from 'react';

export default function ComeOn18Logo(props) {
    return (
        <svg
            x="0px"
            y="0px"
            width="150px"
            height="150px"
            viewBox="0 0 150 150"
            enableBackground="0 0 150 150"
            {...props}
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(3.000000, 3.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <path
                        d="M72,5.76 C108.576,5.76 138.24,35.424 138.24,72 C138.24,108.576 108.576,138.24 72,138.24 C35.424,138.24 5.76,108.576 5.76,72 C5.76,35.424 35.424,5.76 72,5.76 Z M72,0 C32.256,0 0,32.256 0,72 C0,111.744 32.256,144 72,144 C111.744,144 144,111.744 144,72 C144,32.256 111.744,0 72,0 Z"
                        id="a"
                    />
                    <path
                        d="M72,14.0059172 C103.926036,14.0059172 129.994083,40.0739645 129.994083,72 C129.994083,103.926036 103.926036,129.994083 72,129.994083 C40.0739645,129.994083 14.0059172,103.926036 14.0059172,72 C14.0059172,40.0739645 40.0739645,14.0059172 72,14.0059172 Z M72,11.0769231 C38.316568,11.0769231 11.0769231,38.316568 11.0769231,72 C11.0769231,105.683432 38.316568,132.923077 72,132.923077 C105.683432,132.923077 132.923077,105.683432 132.923077,72 C132.923077,38.316568 105.683432,11.0769231 72,11.0769231 Z"
                        id="b"
                    />
                    <polygon
                        id="c"
                        points="44.3076923 84.9230769 44.3076923 81.0161002 48.7384615 81.0161002 48.7384615 63.8855098 44.3076923 63.8855098 44.3076923 60.5796064 54.0553846 59.0769231 54.0553846 81.0161002 59.0769231 81.0161002 59.0769231 84.9230769"
                    />
                    <path
                        d="M71.994796,84.9230769 C68.8235079,84.9230769 62.7692308,83.761452 62.7692308,78.53414 C62.7692308,74.1780467 65.9405188,73.306828 67.9586112,72.4356093 L67.9586112,72.1452031 C66.5171166,71.8547969 63.0575297,69.8219533 63.0575297,66.0466724 C63.0575297,61.4001729 67.0937145,59.0769231 71.7064971,59.0769231 C76.3192797,59.0769231 80.0671656,61.1097666 80.0671656,65.46586 C80.0671656,68.3699222 77.7607742,69.8219533 75.4543829,70.4027658 L75.4543829,70.693172 C76.6075786,70.9835782 81.2203612,72.4356093 81.2203612,77.6629213 C81.5086601,83.1806396 75.7426819,84.9230769 71.994796,84.9230769 Z M71.7064971,73.5972342 C70.5533014,74.1780467 67.6703123,75.0492653 67.6703123,77.6629213 C67.6703123,80.5669836 70.2650025,81.4382022 71.7064971,81.4382022 C73.4362906,81.4382022 76.0309808,80.5669836 76.0309808,77.3725151 C76.3192797,74.7588591 72.5713938,74.1780467 71.7064971,73.5972342 Z M71.7064971,62.2713915 C69.9767036,62.2713915 68.2469101,63.1426102 68.2469101,65.7562662 C68.2469101,68.3699222 71.4181982,69.2411409 72.2830949,69.5315471 C73.1479916,69.5315471 75.7426819,68.079516 75.7426819,65.7562662 C75.166084,63.1426102 73.7245895,62.2713915 71.7064971,62.2713915 Z"
                        id="d"
                    />
                    <polygon
                        id="e"
                        points="98.1538462 76.0615385 98.1538462 84.9230769 93.8461538 84.9230769 93.8461538 76.0615385 84.9230769 76.0615385 84.9230769 71.6307692 93.8461538 71.6307692 93.8461538 62.7692308 98.1538462 62.7692308 98.1538462 71.6307692 107.076923 71.6307692 107.076923 76.0615385"
                    />
                </g>
            </g>
        </svg>
    );
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/svg/comeon18.js
 **/